import React, { FC } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

import nameSpace from '../i18nNameSpace';
import styles from './DownloadProtectionPopup.module.scss';

interface DownloadProtectionPopupProps {
    filename: string;
    hint: string | null;
    onClose: () => void;
}

const DownloadProtectionPopup: FC<DownloadProtectionPopupProps> = ({
    filename,
    hint,
    onClose,
}) => {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.title}>
                    {t(`${nameSpace}.downloadProtection.title`)}
                </div>
                <CloseOutlined className={styles['close-icon']} onClick={onClose} />
            </div>
            <Divider className={styles.divider} />
            <div className={styles.description}>
                <Trans
                    i18nKey={`${nameSpace}.downloadProtection.description`}
                    t={t}
                    values={{ filename }}
                    components={{ 1: <span className={styles.filename} /> }}
                />
            </div>
            {hint && (
                <div className={styles['hint-section']}>
                    <div className={styles['hint-label']}>
                        {t(`${nameSpace}.downloadProtection.hintLabel`)}
                    </div>
                    <div className={styles['hint-text']}>
                        {hint}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DownloadProtectionPopup;
